// extracted by mini-css-extract-plugin
export default {"container":"CustomerWaitingForPayment_container__pLFJG","loader":"CustomerWaitingForPayment_loader__pSMQM","spin":"CustomerWaitingForPayment_spin__3PRma"};